module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('home-app-banner'), _vm._v(" "), _c('home-app-content')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-81066768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/app/HomeApp.vue
// module id = 165
// module chunks = 1